import { render, staticRenderFns } from "./LandedCostBreakdown.vue?vue&type=template&id=608fdd34&scoped=true"
import script from "./LandedCostBreakdown.vue?vue&type=script&lang=ts"
export * from "./LandedCostBreakdown.vue?vue&type=script&lang=ts"
import style0 from "./LandedCostBreakdown.vue?vue&type=style&index=0&id=608fdd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608fdd34",
  null
  
)

export default component.exports